import { Injectable } from "@angular/core";
import { CanDeactivate } from "@angular/router";
import { TravelKitModifyComponent } from "src/app/modules/digital-memory-log/components/travel-kit-modify/travel-kit-modify";

@Injectable({
  providedIn: "root",
})
export class UnsavedChangesGuard implements CanDeactivate<TravelKitModifyComponent> {
  canDeactivate(component: TravelKitModifyComponent): Promise<boolean> | boolean {
    return component.canDeactivate();
  }
}
